"use client";

import useSWR from "swr";
import RelatedArticles, { ArticleCard } from "./related-articles";
import RelatedArticlesSkeleton from "./related-articles.skeleton";
import { getRelatedArticles } from "@/lib/builder-utils";
import { builder, BuilderContent } from "@builder.io/sdk";
import {
  withUrl,
  calculateTimeToRead,
  calculateBuilderWordCount,
} from "@/lib/utils";
import { format } from "date-fns";

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

export type RelatedArticlesControlledProps = {
  blogId: string;
  isEditing?: boolean;
};

const RelatedArticlesControlled: React.FC<RelatedArticlesControlledProps> = ({
  blogId,
  isEditing,
}) => {
  const fetcher = async ([_]: [string]) =>
    await getRelatedArticles(builder, blogId);

  const { data, isLoading } = useSWR([`related-articles-${blogId}`], fetcher);
  const articles: ArticleCard[] =
    (data
      ?.map((article: BuilderContent) => ({
        title: (article.data?.blogPostTitle as string) ?? "",
        titleHref: withUrl(`${article.data?.url}`),
        text: (article.data?.blogPostBlurb as string) ?? "",
        leftInfo: `${format(new Date(article?.lastUpdated ?? 0), "MMMM d, yyyy")}`,
        rightInfo: `${calculateTimeToRead(
          calculateBuilderWordCount(article.data?.blocks)
        )} min read`,
      }))
      ?.filter(Boolean) as ArticleCard[]) ?? [];

  if (isLoading || isEditing) return <RelatedArticlesSkeleton />;

  return <RelatedArticles articles={articles} />;
};

export default RelatedArticlesControlled;
